<template>
  <div class="d-flex flex-row flex-row-wrapper">
    <div class="f-3">
      <p>{{ this.lable }}</p>
    </div>
    <div class="f-5">
      <p>{{ this.value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['lable', 'value'],
  data: () => ({})
}
</script>

<style lang="scss" scoped>
.flex-row-wrapper {
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
}
.flex-row-wrapper p {
  font-size: 14px;
}
.flex-row-wrapper div:first-child p {
  font-weight: bold;
}
.f-3 {
  flex: 3;
}
.f-5 {
  flex: 5;
}
</style>
